import * as yup from 'yup';

const GENERIC_POSTAL_PATTERN = /^[A-Za-z0-9][A-Za-z0-9\s-]{2,11}$/;

export const editProfileSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  profile: yup.string(),
  dateOfBirth: yup.string().required('Date of birth is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  contactNumber: yup.string().required('Contact number is required'),
  address: yup.string().required('Address is required'),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  zipCode: yup
    .string()
    .required('Zip code is required')
    .test('zip-generic', 'Invalid zip/postal code format', value => {
      if (!value) return true;
      return GENERIC_POSTAL_PATTERN.test(value.trim());
    }),
  country: yup.string().required('Country is required')
});
